import { initAnimStack } from "./animStack";

// window.addEventListener("anim-stack:ready", (event) => {
//   const { lenis, gsap, ScrollTrigger } = event.detail;
//   console.log("animation stack ready", lenis, gsap, ScrollTrigger);
// });

initAnimStack();
